export enum ContractorTypeEnum {
    reception = "Recepcion",
    installation = "Instalacion",
}

export enum ContractorStatusEnum {
    new = "Nueva",
    incomplete = "Incompleta",
    complete = "Completa",
}